import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';


@Component({
  selector: 'app-upload-apo-steps',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule],
  templateUrl: './upload-apo-steps.component.html',
  styleUrl: './upload-apo-steps.component.scss'
})
export class UploadApoStepsComponent {
  @Input() steps: any;
  @Output() onSelectTab: any = new EventEmitter();

  faCircle = faCircle;
  faCircleCheck = faCircleCheck;

  
  ngOnInit() {
    
  }

  selectTab(tab: any) {
    this.steps.map((step: any) => step.active = false);
    tab.active = true;
    this.onSelectTab.emit(tab);
  }

}
